var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"companyinfo",on:{"click":function($event){return _vm.go_up()}}},[_c('router-link',{attrs:{"to":{'name': 'index'}}},[_c('img',{attrs:{"src":"src/assets/img/logo.png","alt":"LN Repuestos"}}),_vm._v("\n        Especialistas en Volvo\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }